import React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import "./styles.css";

export const Dialog = DialogPrimitive.Root;
export const DialogTrigger = DialogPrimitive.Trigger;
export const DialogClose = DialogPrimitive.Close;

export const DialogOverlay = React.forwardRef((props, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className="custom-signal-com-required-overlay"
    {...props}
  />
));

export const DialogContent = React.forwardRef(
  ({ children, className = "", ...props }, ref) => (
    <DialogPrimitive.Portal>
      <DialogOverlay />
      <DialogPrimitive.Content
        ref={ref}
        className={`custom-signal-com-required-dialog ${className}`}
        {...props}
      >
        {children}
        <DialogPrimitive.Close className="custom-signal-com-required-close">
          <X size={16} />
        </DialogPrimitive.Close>
      </DialogPrimitive.Content>
    </DialogPrimitive.Portal>
  )
);

export const DialogHeader = ({ children }) => (
  <div className="custom-signal-com-required-header">{children}</div>
);

export const DialogFooter = ({ children }) => (
  <div className="custom-signal-com-required-footer">{children}</div>
);

export const DialogTitle = React.forwardRef((props, ref) => (
  <DialogPrimitive.Title
    ref={ref}
    className="custom-signal-com-required-title"
    {...props}
  />
));

export const DialogDescription = React.forwardRef((props, ref) => (
  <DialogPrimitive.Description
    ref={ref}
    className="custom-signal-com-required-description"
    {...props}
  />
));